import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { anonymousClient } from "./anonymous/client";

type Input = {
  baseURL: string;
};
export const buildAuthClient = ({ baseURL }: Input) =>
  createAuthClient({
    plugins: [magicLinkClient(), anonymousClient()],
    baseURL,
  });
